import { ExerciseList } from '#shared/exercise/exercise-list';
import { IExercisePresetWorkout } from '#types/exercisePresets';
import { useEffect, useState } from 'react';
import { ExerciseMemo } from '../components/ExerciseMemo';
import { useDashboardCharFormExerciseState } from '../states/dashboardCharFormExerciseState';
import { useDraftChartForEdit } from './useDraftChartForEdit';

export const ChartFormEditExerciseList = () => {
  const { draftChart } = useDraftChartForEdit({
    suspense: true
  });

  const [exerciseList, setExerciseList] = useState<IExercisePresetWorkout[]>(
    []
  );

  const { records, setRecords } = useDashboardCharFormExerciseState();

  useEffect(() => {
    setExerciseList(
      records.map(record => ({
        exerciseTypeId: record.exerciseTypeId,
        sets: record.sets
      }))
    );
  }, [records]);

  useEffect(() => {
    if (exerciseList.length === 0 && records.length === 0) {
      setRecords([
        {
          exerciseKind: '',
          sets: [
            {
              weight: 0,
              reps: 0,
              time: 0,
              setType: 'REPWEIGHT',
              round: 0
            }
          ],
          exerciseTypeId: ''
        }
      ]);
    }
  }, [exerciseList, records]);

  // 임시 저장된 운동차트 정보가 있을 경우
  useEffect(() => {
    if (!draftChart) return;

    setRecords(
      draftChart.records.map(record => {
        const sets = record.sets.map(set => ({
          weight: set.weight,
          reps: set.reps,
          time: set.time,
          setType: set.setType,
          round: set.round
        }));

        return {
          exerciseKind: record.exerciseKind,
          sets,
          exerciseTypeId: record.exerciseTypeId
        };
      })
    );
  }, [draftChart]);

  return (
    <>
      <ExerciseList exerciseList={exerciseList}>
        <ExerciseMemo />
      </ExerciseList>
    </>
  );
};
